import { useMemo } from 'react';
import cn from '@/utils/merge-class-names';

interface Props {
  progress?: number;
  duration?: number;
  count?: number;
  className?: string;
}

const BAR_HEIGHT_MAX = 24;
const BAR_HEIGHT_MIN = 3;

export default function AudioBars({ count, duration = 0, progress = 0, className }: Props) {
  const bars = useMemo(
    () =>
      Array.from({ length: count ?? Math.min(30, Math.floor(duration + 5)) }).map(
        () => Math.random() * (BAR_HEIGHT_MAX - BAR_HEIGHT_MIN) + BAR_HEIGHT_MIN,
      ),
    [duration, count],
  );

  return (
    <div
      className='inline-flex items-center gap-0.5'
      style={{
        maskImage: `linear-gradient(90deg, #000, #000 ${progress}%, rgba(130,141,169,0.3) ${progress}%, rgba(130,141,169,0.3))`,
      }}>
      {bars.map((height, index) => (
        <div
          key={index}
          className={cn('w-0.5 rounded-full transition-all duration-300 ease-in-out', className)}
          style={{ height }}
        />
      ))}
    </div>
  );
}
